import React, { useEffect, useState } from "react";
import "./users.css";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";

import Loader from "../../components/Loader/Loader";

import moment from "moment";
const SingleUsers = () => {
  const [data, setData] = useState();
  const [popupShow, setPopupShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { currUserData } = useAuthContext();

  const { id } = useParams();
  const navigate = useNavigate();

  console.log(id);

  const getSingleUser = async () => {
    setIsLoading(true);

    let res = await api(
      `api/v1/admin/OwnerList?limit=10`,
      "",
      "post",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      // setSubscriptionData(res?.data);

      const pathId = id;

      const singleData = res?.data.find(
        (itemInArray) => itemInArray._id === pathId
      );

      console.log(singleData, "singleData");

      setData(singleData);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getSingleUser();
  }, []);

  return (
    <>
      <div className="single_service_log p-40">
        <div className="page_heading mb-5">
          <div>
            <p className="heading">Owner Details</p>
            <span>
              <i class="fas fa-home"></i>{" "}
              <i class="fas fa-chevron-right me-1 ms-1"></i> Users
              <i class="fas fa-chevron-right me-1 ms-1"></i> Owners
              <i class="fas fa-chevron-right me-1 ms-1"></i> Owner Details
            </span>
          </div>
          <button className="btn_primary btn_md" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>

        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="service_box">
              <div className="service_details mb-4">
                <div className="row">
                  <div className="col-md-4">
                    <h5>Owner Details</h5>
                    <ul>
                      <li>
                        <p>Owner Name</p>
                        <span>: {data?.name}</span>
                      </li>
                      {/* <li>
                        <p>Relation</p>
                        <span>: {data?.userType}</span>
                      </li> */}
                      <li>
                        <p>Phone Number</p>
                        <span>: {data?.mobile}</span>
                      </li>
                      {/* <li>
                        <p>Alternate Phone Number</p>
                        <span>: {data?.alternateMobile}</span>
                      </li> */}
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <h5>Address</h5>
                    <ul>
                      {/* <li>
                        <p>Hno./Street/Colony</p>
                        <span>: {data?.street}</span>
                      </li>
                      <li>
                        <p>City</p>
                        <span>: {data?.city}</span>
                      </li> */}
                      <li>
                        <p>Zipcode</p>
                        <span>: {data?.zipcode}</span>
                      </li>
                      {/* <li>
                        <p>State</p>
                        <span>: {data?.state}</span>
                      </li> */}
                      {/* <li>
                        <p>Country</p>
                        <span>: {data?.country}</span>
                      </li> */}
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <h5>Pets</h5>
                    <ul>
                      <li>
                        <p>No.of Pets</p>
                        <span>: {data?.noOfPets}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column gap-6 pb-5">
                <h5 class="f-600 text-black mb-4">Pet Details</h5>

                {data?.petsDetails.length > 0 ? (
                  data?.petsDetails.map((item, index) => {
                    return (
                      <>
                        <div class="row SingleOwner_pet_details d-flex d-justify-space-between gap-10 mb-3 gy-4">
                          <div class="col-md-5 d-flex d-align-center gap-3">
                            <img
                              class="rounded-circle"
                              width="77"
                              height="77"
                              src={item?.image}
                              alt="pet-img"
                            />
                            <div class="d-flex flex-column">
                              <h5 class="f-600 text-black">{item?.name}</h5>
                              <div class="d-flex d-align-center gap-2">
                                <h5 class="f-400 l-20 text-black">
                                  {item?.breed}
                                </h5>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="2"
                                  height="15"
                                  viewBox="0 0 2 15"
                                  fill="none"
                                >
                                  <path
                                    d="M1 1.31238V13.4673"
                                    stroke="#9B9B9B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                  ></path>
                                </svg>
                                <h5 class="f-400 l-20 text-black">
                                  {item?.gender}
                                </h5>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="2"
                                  height="15"
                                  viewBox="0 0 2 15"
                                  fill="none"
                                >
                                  <path
                                    d="M1 1.31238V13.4673"
                                    stroke="#9B9B9B"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                  ></path>
                                </svg>
                                <h5 class="f-400 l-20 text-black">
                                  {item?.age?.year}.{item?.age?.month} Mon
                                </h5>
                              </div>
                            </div>
                          </div>
                          <div class="col-7 d-flex justify-content-between gap-2">
                            <div class="d-flex flex-column gap-2">
                              <h5 class="f-400 l-20 ">Color</h5>
                              <h6 class="f-400 l-20 ">{item?.color}</h6>
                            </div>
                            <div class="d-flex flex-column gap-2">
                              <h5 class="f-400 l-20 ">DOB</h5>
                              <h6 class="f-400 l-20 ">
                                {moment(item?.dob, "YYYY-MM-DD").format(
                                  "DD/MM/YYYY"
                                )}
                              </h6>
                            </div>
                            <div class="d-flex flex-column gap-2">
                              <h5 class="f-400 l-20 ">Aggression</h5>
                              <h6 class="f-400 l-20 ">{item?.aggression}</h6>
                            </div>
                            <div class="d-flex flex-column gap-2">
                              <h5 class="f-400 l-20 ">Weight</h5>
                              <h6 class="f-400 l-20 ">{item?.weight}</h6>
                            </div>
                            <div class="d-flex flex-column gap-2">
                              <h5 class="f-400 l-20 ">Size</h5>
                              <h6 class="f-400 l-20 ">{item?.size}</h6>
                            </div>
                          </div>
                          <div class="col-6 d-flex flex-column gap-3 ps-4">
                            <h5 class="f-500 l-20 text-black">
                              Diet &amp; Notes
                            </h5>
                            <p class="f-400 l-20 text-gray m-0">{item?.diet}</p>
                          </div>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <p
                    style={{
                      fontSize: "15px",
                      marginTop: "10px",
                      textAlign: "center",
                    }}
                  >
                    No Pet Details
                  </p>
                )}
              </div>
              <div className="col-12 col-md-7 col-lg-5 d-flex flex-column gap-4">
                <div className="d-flex flex-column gap-3 border-bottom-gray pb-5">
                  <h5 className="f-500 l-20 text-black">Insurance Info</h5>
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex d-align-center gap-1">
                      <h5 className="f-400 text-gray">
                        Does your pet have Insurance?
                      </h5>
                      <h5 className="f-400 text-black">
                        : {data?.insuranceInfo?.isHave ? "True" : "False"}
                      </h5>
                    </div>
                    <div className="d-flex d-align-center gap-1">
                      <h5 className="f-400 text-gray">Insurance Company</h5>
                      <h5 className="f-400 text-black">
                        : {data?.insuranceInfo?.company}
                      </h5>
                    </div>
                    <div className="d-flex d-align-center gap-1">
                      <h5 className="f-400 text-gray">Insurance Number</h5>
                      <h5 className="f-400 text-black">
                        : {data?.insuranceInfo?.number}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column gap-3 border-bottom-gray pb-5">
                  <div className="d-flex flex-column gap-3">
                    <h5 className="f-400 l-20 text-black">License Info</h5>
                    <div className="d-flex d-align-center gap-1">
                      <h6 className="f-400 text-gray">
                        Does your pet have License? :
                      </h6>
                      <h6 className="f-400 text-black">
                        {data?.licenseInfo?.isHave ? "True" : "False"}
                      </h6>
                    </div>
                  </div>
                  {/* <img
                    className="rounded-circle"
                    width={106}
                    height={106}
             
                    alt="license-img"
                  /> */}
                </div>
                <div className="d-flex d-align-center d-justify-space-between">
                  <h5 className="f-600 l-20 text-black">Doctor Prescription</h5>
                  <h5 className="f-600 l-20 text-gray">NA</h5>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SingleUsers;
